import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useInputClassName } from "../hooks/useInputClassName.js";
import { useComponentClassName } from "../../../auxiliary/useComponentClassName.js";
import { toStateClass } from "../../../utils/toStateClass.js";
const CheckboxButton = ({
  id,
  name,
  placeholder,
  checked,
  indeterminate,
  ...props
}) => {
  const componentClassName = useComponentClassName("checkbox-button");
  return /* @__PURE__ */ jsx(
    "span",
    {
      id,
      className: classNames(
        componentClassName,
        toStateClass("checked", checked === true),
        toStateClass("indeterminate", indeterminate),
        useInputClassName(props)
      ),
      children: indeterminate ? /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: `${componentClassName}-questionmark`, children: "?" }) : void 0
    }
  );
};
export {
  CheckboxButton
};
//# sourceMappingURL=CheckboxButton.js.map
